import React from 'react';
import styles from './PFSPremierPartner.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';
import { NavLink, useLocation } from 'react-router-dom';
import PremierLogo from './PremierLogo.png';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { PartnersIndexBreadcrumb } from '../PFSPartnersIndex/PFSPartnersIndex';

const PFSPremierPartner = () => {
    const { pathname } = useLocation();

    useBreadcrumb([
        PartnersIndexBreadcrumb,
        {
            label: 'Premier Computer Consulting',
            url: pathname
        }
    ]);

    return (
        <div className={styles.PfsPremierPartner} data-testid='PfsPremierPartner'>
            <ContentContainer>
                <img src={PremierLogo} className={styles.PremierLogo} alt="Premier Logo" />

                <header className={styles.header}>
                    <h1 className={styles.title}>Premier Computer Consulting</h1>
                    <p className={styles.description}>
                        Premier Computer Consulting is a trusted Southern California IT partner delivering comprehensive managed
                        services, cloud solutions, cybersecurity, and business communications. We help organizations operate
                        securely and efficiently through proactive support, modern technology platforms, and reliable
                        infrastructure management.
                    </p>
                </header>

                <main className={styles.content}>
                    <section className={styles.section}>
                        <h2>Managed Services</h2>
                        <p>Premier provides full-service IT management designed to keep systems
                            running smoothly and securely.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>Unlimited phone and remote support for managed devices</li>
                            <li className={styles.listItem}>Automated patching of systems</li>
                            <li className={styles.listItem}>24/7 system monitoring</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>VoIP & Business Communications</h2>
                        <p>We deliver modern communication tools that keep teams connected from
                            anywhere.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>VoIP phone system setup and management</li>
                            <li className={styles.listItem}>Video meetings, chat, and SMS</li>
                            <li className={styles.listItem}>Contact center solutions</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>Microsoft 365 Solutions</h2>
                        <p>As a Microsoft-focused partner, Premier manages the full Microsoft 365
                            ecosystem to enhance productivity and collaboration.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>User management and licensing</li>
                            <li className={styles.listItem}>Teams management for meetings and chat</li>
                            <li className={styles.listItem}>OneDrive and SharePoint for file sharing</li>
                            <li className={styles.listItem}>Azure VMs for hosted servers</li>
                            <li className={styles.listItem}>Entra ID for security and compliance</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>Hosted Cloud Services</h2>
                        <p>We support cloud-first and hybrid environments with secure, scalable
                            infrastructure.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>Endpoint Detection and Response (EDR)</li>
                            <li className={styles.listItem}>Data center co-location and management</li>
                            <li className={styles.listItem}>Cloud virtual machines</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>Cybersecurity</h2>
                        <p>Premier protects businesses with layered security solutions and
                            continuous monitoring.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>Endpoint Detection and Response (EDR)</li>
                            <li className={styles.listItem}>Managed and monitored antivirus</li>
                            <li className={styles.listItem}>Firewall management</li>
                            <li className={styles.listItem}>Compliance support</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>Business Continuity & Compliance</h2>
                        <p>We ensure business resilience with reliable backup and recovery
                            solutions.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>Cloud backup with continuity</li>
                            <li className={styles.listItem}>Local backup configuration and monitoring</li>
                            <li className={styles.listItem}>Email and voice archiving</li>
                            <li className={styles.listItem}>Cloud-based recovery for rapid access during outages</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>Networking & On-Premises Infrastructure</h2>
                        <p>Premier designs, deploys, and supports the full range of on-premises
                            technology systems.</p>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>Firewall and router configuration</li>
                            <li className={styles.listItem}>Server, workstation, and whole-office setup</li>
                            <li className={styles.listItem}>IT equipment and hardware ordering</li>
                            <li className={styles.listItem}>WiFi and printing</li>
                            <li className={styles.listItem}>Cabling and camera systems</li>
                        </ul>
                    </section>

                    <footer className={styles.footer}>
                        <h2>Contact Premier Computer Consulting</h2>
                        <div className={styles.contactInfo}>
                            <p>
                                <strong>Website:</strong>
                                <a href="https://www.precompco.com" target="_blank" rel="noopener noreferrer">
                                    www.precompco.com
                                </a>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <a href="tel:+17147063900">(714) 706-3900</a>
                            </p>
                        </div>
                    </footer>

                    <NavLink to={'/who-we-trust'} id={styles.homeBtn}>
                        Back to Who We Trust
                    </NavLink>
                </main>
            </ContentContainer>
        </div>
    );
};

export default PFSPremierPartner;
